import { useEffect, useState } from "react";

import { MEDIA_QUERY } from "../styles/breakpoints";

const getMatch = query =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(query).matches
    : false;

// Subscribes to a media query and returns whether it currently matches.
// Reads the same MEDIA_QUERY constants as the CSS media helper, so the JS view
// of "mobile" stays in lockstep with the styled-components breakpoints.
const useMediaQuery = query => {
  const [matches, setMatches] = useState(() => getMatch(query));

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const mql = window.matchMedia(query);
    const handler = event => setMatches(event.matches);

    // Sync in case the query changed between the initial render and this effect.
    setMatches(mql.matches);

    // Safari < 14 only supports the deprecated add/removeListener API.
    if (mql.addEventListener) mql.addEventListener("change", handler);
    else mql.addListener(handler);

    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;

// THE predicate the app shell uses to decide hamburger-drawer vs fixed sidebar.
export const useIsMobileLayout = () => useMediaQuery(MEDIA_QUERY.maxTablet);
